import React from 'react';
import { useTranslate } from 'react-admin';
import { Drawer } from '~/components';
import { EditForm } from '~/components/ra';
import { Mapping } from '~/types/Menu';
import MappingsForm from './MappingsForm';

const l = (key: string): string => `resources.menu.fields.${key}`;

interface Props {
  record: Mapping | null;
  open: boolean;
  onClose: () => void;
  closeParent: () => void;
  permissions: string[];
}

const MappingsEdit = (props: Props) => {
  const { record, open, onClose, closeParent, permissions } = props;

  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));

  const closeAll = () => {
    onClose();
    closeParent();
  };

  return (
    <Drawer heading={t('editMapping')} open={open} onClose={onClose}>
      {record && (
        <EditForm
          resource='menu/mappings'
          id={record.id}
          resourceId={record.id}
          record={record}
          closeParent={closeAll}
          withDelete
          disabled={!permissions?.includes('dynamicMenu.update')}
          withSaveConfirmation
          withDeleteConfirmation
          deleteButtonProps={{
            variant: 'delete',
            disabled: !permissions?.includes('dynamicMenu.delete'),
          }}
        >
          <MappingsForm edit />
        </EditForm>
      )}
    </Drawer>
  );
};

export default MappingsEdit;
